import { createEnum } from "@redotech/zod-util/zod-enum";

export enum ProductProcessingSpecKind {
  EVALUATION = "evaluation",
  VALIDATION = "validation",
}
export const ProductProcessingSpecKindSchema = createEnum(
  ProductProcessingSpecKind,
);

export enum ReturnProcessingFlowRule {
  ITEM_LIKE_NEW = "item_like_new",
  FACTORY_SEALED = "factory_sealed",
  NEW_CONDITION = "new_condition",
  ITEM_WEAR = "item_wear",
  NEW_CONDITION_AFTER_CLEANING = "new_condition_after_cleaning",
}
export const ReturnProcessingFlowRuleSchema = createEnum(
  ReturnProcessingFlowRule,
);

export const RETURN_PROCESSING_FLOW_RULES = [
  ReturnProcessingFlowRule.ITEM_LIKE_NEW,
  ReturnProcessingFlowRule.FACTORY_SEALED,
  ReturnProcessingFlowRule.NEW_CONDITION,
  ReturnProcessingFlowRule.ITEM_WEAR,
  ReturnProcessingFlowRule.NEW_CONDITION_AFTER_CLEANING,
] as const;

export enum ProductProcessingSpecViewRule {
  VIEW = "view",
}
export const ProductProcessingSpecViewRuleSchema = createEnum(
  ProductProcessingSpecViewRule,
);

export const PRODUCT_PROCESSING_SPEC_VIEW_RULES = [
  ProductProcessingSpecViewRule.VIEW,
] as const;

export enum ReturnItemDispositionRule {
  RESTOCK = "restock",
  DONATE = "donate",
  RECYCLE = "recycle",
  REFURBISH = "refurbish",
  RESELL = "resell",
}
export const ReturnItemDispositionRuleSchema = createEnum(
  ReturnItemDispositionRule,
);

export const RETURN_ITEM_DISPOSITION_RULES = [
  ReturnItemDispositionRule.RESTOCK,
  ReturnItemDispositionRule.DONATE,
  ReturnItemDispositionRule.RECYCLE,
  ReturnItemDispositionRule.REFURBISH,
  ReturnItemDispositionRule.RESELL,
] as const;

export const PRODUCT_PROCESSING_SPEC_RULES = [
  ...RETURN_PROCESSING_FLOW_RULES,
  ...PRODUCT_PROCESSING_SPEC_VIEW_RULES,
  ...RETURN_ITEM_DISPOSITION_RULES,
] as const;

export const ProductProcessingSpecRule = {
  ...ReturnProcessingFlowRule,
  ...ProductProcessingSpecViewRule,
  ...ReturnItemDispositionRule,
} as const;
export type ProductProcessingSpecRule =
  (typeof PRODUCT_PROCESSING_SPEC_RULES)[number];
export const ProductProcessingSpecRuleSchema = createEnum(
  PRODUCT_PROCESSING_SPEC_RULES,
);
